<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'resource'],
		data () {
			return {
				modal: {
					selector: 'modal-create-' + new Date().getTime()
				},
				autocomplete: null,
				place: {
					formatted_address: null,
					name: null,
					google_place_id: null,
					url: null,
					country: null,
					country_short_name: null,
					postal_code: null,
					administrative_area_level_1: null,
					administrative_area_level_2: null,
					locality: null,
					route: null,
					street_number: null,
					sublocality_level_1: null,
					sublocality_level_2: null,
					lat: null,
					lng: null,
				}
			}
		},
		methods: {
			open(place) {
				$('#input-autocomplete-create').val('')
				this.initAutocomplete()
				this.clearData()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')

				if(place) {
					this.loadPlace(place)
				}
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				for(var value in this.place) {
					this.place[value] = null
				}
			},
			initAutocomplete() {
				var that = this
				this.autocomplete = new google.maps.places.Autocomplete(
					(that.$refs.inputAutocompleteCreate),
					{types: ['geocode']}
				);
				this.autocomplete.addListener('place_changed', function(event) {
					var place = that.autocomplete.getPlace();
					if(place) {
						that.loadPlace(place)
					}
				})
			},
			loadPlace(place) {
				this.clearData()
				var that = this
				this.place.formatted_address = place.formatted_address
				this.place.name = place.name
				this.place.google_place_id = place.place_id
				this.place.url = place.url

				this.place.lat = place.geometry.location.lat()
				this.place.lng = place.geometry.location.lng()

				var address_components = []
				if(place.address_components) {
					place.address_components.forEach(function(element) {
						var type = element.types[0]
						var component = {
							type: type,
							value: element.long_name
						}
						address_components.push(component)
						if(type == 'country') {
							var component = {
								type: 'country_short_name',
								value: element.short_name
							}
							address_components.push(component)
						}
					})
				}
				address_components.forEach(function(element) {
					if(that.place[element.type] !== 'undefined') {
						that.place[element.type] = element.value
					}
				})
			},
			store() {
				if(this.place) {
					var loading = Ladda.create(this.$refs.btnStore)
					loading.start()
					this.$http.post(this.resource + '/places', this.place)
					.then(response => {
						loading.stop()
						this.$emit('reload', {
							place: response.body.data
						})
						this.clearData()
						this.close()
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}).catch(function(response) {
						loading.stop()
						this.$emit('reload')
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning",
						})
					})
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/places/views/Create.vue